/* =============================================================================
   DEFERRED VIDEO
   snippets/media.liquid renders videos with their poster image only. This
   attaches the video file once the page has loaded, so video never competes
   with the first paint. Visitors with data saver on get the video on tap.
   ============================================================================= */

(function() {
  'use strict';

  var saveData = navigator.connection && navigator.connection.saveData;
  var pageLoaded = false;

  function isOnScreen(element) {
    var rect = element.getBoundingClientRect();

    return rect.width > 0 && rect.height > 0 &&
      rect.bottom > 0 && rect.top < window.innerHeight &&
      rect.right > 0 && rect.left < window.innerWidth;
  }

  function attach(video) {
    var sources = video.querySelectorAll('source[data-src]');

    if (!sources.length) return;

    // A sharper mp4 for larger screens when the section provides one (data-src-desktop). Then the HLS source is
    // dropped so Safari on desktop uses that file too.
    var isDesktop = window.matchMedia('(min-width: 700px)').matches;
    var hasDesktopSrc = !!video.querySelector('source[data-src-desktop]');

    sources.forEach(function(source) {
      if (source.hasAttribute('data-hls') && isDesktop && hasDesktopSrc) {
        source.remove();
        return;
      }

      var desktopSrc = source.getAttribute('data-src-desktop');
      source.src = (desktopSrc && isDesktop) ? desktopSrc : source.getAttribute('data-src');
      source.removeAttribute('data-src');
      source.removeAttribute('data-src-desktop');
    });

    video.removeAttribute('data-deferred-video');
    video.preload = 'metadata';
    video.load();

    // The theme's <video-media> may have tried to autoplay before the file was attached (or before the element
    // was on screen, e.g. carousels and sections loaded after the page such as Recently viewed), so play it
    // whenever it comes into view and pause it when it leaves
    var videoMedia = video.closest('video-media');

    if (videoMedia && videoMedia.hasAttribute('autoplay')) {
      watchAutoplay(video, videoMedia);
    }
  }

  var autoplayObserver = ('IntersectionObserver' in window) ? new IntersectionObserver(function(entries) {
    entries.forEach(function(entry) {
      var video = entry.target;

      var needed = video.closest('.product-gallery') ? 0.6 : 0.2;

      if (entry.isIntersecting && entry.intersectionRatio >= needed) {
        var playing = video.play();

        if (playing) playing.catch(function() {});
      } else if (!video.paused) {
        video.pause();
      }
    });
  }, { threshold: [0.2, 0.6] }) : null;

  function watchAutoplay(video, videoMedia) {
    // Mark the wrapper loaded once playing so the theme's fade (video-media:not([loaded]) > video) lets it show
    video.addEventListener('playing', function() { videoMedia.setAttribute('loaded', ''); }, { once: true });

    // Observe the video itself: product-card wrappers are display: contents, so they have no box to intersect
    if (autoplayObserver) {
      autoplayObserver.observe(video);
    } else if (isOnScreen(video)) {
      var playing = video.play();

      if (playing) playing.catch(function() {});
    }
  }

  function attachOnTap(video) {
    var target = video.closest('video-media') || video;

    target.addEventListener('click', function() {
      attach(video);
    }, { once: true });
  }

  // Autoplaying videos (cards, homepage sections) get their file only when they come near the screen. Browsers that
  // play HLS natively (Safari, recent Chrome) otherwise buffer several 1080p segments for every video on the page.
  var nearObserver = ('IntersectionObserver' in window) ? new IntersectionObserver(function(entries) {
    entries.forEach(function(entry) {
      if (!entry.isIntersecting) return;

      nearObserver.unobserve(entry.target);
      attach(entry.target);
    });
  }, { rootMargin: '200px 0px' }) : null;

  // Product gallery videos: the next slide peeks in from the side on phones, which counts as "on screen".
  // Only load (and so play) a gallery video once its slide is mostly in view, so a video the shopper hasn't
  // swiped to never downloads.
  var galleryObserver = ('IntersectionObserver' in window) ? new IntersectionObserver(function(entries) {
    entries.forEach(function(entry) {
      if (!entry.isIntersecting || entry.intersectionRatio < 0.6) return;

      galleryObserver.unobserve(entry.target);
      attach(entry.target);
    });
  }, { threshold: [0.6] }) : null;

  function handle(video) {
    if (saveData) return attachOnTap(video);

    var videoMedia = video.closest('video-media');

    if (galleryObserver && video.closest('.product-gallery')) {
      galleryObserver.observe(video);
    } else if (nearObserver && videoMedia && videoMedia.hasAttribute('autoplay')) {
      nearObserver.observe(video);
    } else {
      attach(video);
    }
  }

  function handleAll(root) {
    root.querySelectorAll('video[data-deferred-video]').forEach(handle);
  }

  function onLoad() {
    pageLoaded = true;
    handleAll(document);
  }

  if (document.readyState === 'complete') {
    onLoad();
  } else {
    window.addEventListener('load', function() {
      ('requestIdleCallback' in window) ? requestIdleCallback(onLoad, { timeout: 1500 }) : setTimeout(onLoad, 200);
    });
  }

  // Galleries re-rendered after load (variant changes, quick buy) bring new deferred videos
  new MutationObserver(function(mutations) {
    if (!pageLoaded) return;

    mutations.forEach(function(mutation) {
      mutation.addedNodes.forEach(function(node) {
        if (node.nodeType !== 1) return;

        if (node.matches('video[data-deferred-video]')) {
          handle(node);
        } else {
          handleAll(node);
        }
      });
    });
  }).observe(document.documentElement, { childList: true, subtree: true });
})();
